// 거래명세서 인쇄 공용 함수 (2026-10-06 미리보기 A안 — ViewTransactionStatement.handlePrint를 그대로 옮기고
// 미리보기 모달과 공유). 숨은 iframe에 .print-area 안쪽 HTML을 복사해 브라우저 인쇄 대화상자를 연다.
// PDF 저장은 브라우저 인쇄 대화상자의 "PDF로 저장"으로 처리 — 전용 PDF 생성기는 웹에 없음(P2).
//
// 기존 iframe CSS(표 테두리·글꼴)는 그대로 두고, 기획서 3-5에 따라 두 가지를 보탰다:
//   ① 화면의 줄공책 선(.ledger-table)이 iframe에도 적용되게 같은 규칙 삽입(innerHTML 복사라 className 스타일이 안 넘어가던 것)
//   ② .no-print(자동수집/수기 배지 등 화면 전용 표시)를 인쇄물에서 숨김
// 파일명: 브라우저가 문서 제목을 제안 파일명으로 쓰므로 <title>에 `거래명세서_{번호}_{거래처}`를 넣는다 — 환자명은 넣지 않는다.

const escapeHtml = (s) => String(s || '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/** 제안 파일명(=문서 제목). 환자명 제외, 파일명에 못 쓰는 문자 제거. partnerName = 보는 사람 기준 거래처명(없으면 공급받는자) */
export const statementPrintTitle = (statement, partnerName) => {
    const num = String(statement?.statementNumber || '명세서').trim();
    const partner = String(partnerName || statement?.toUserName || '').trim();
    const raw = partner ? `거래명세서_${num}_${partner}` : `거래명세서_${num}`;
    return raw.replace(/[\\/:*?"<>|]/g, '_');
};

/**
 * @param {Object} opts
 * @param {HTMLElement} [opts.root]   인쇄할 .print-area 요소 (없으면 document.querySelector('.print-area'))
 * @param {string}      [opts.title]  iframe 문서 제목(=PDF 저장 시 제안 파일명)
 * @returns {boolean} 인쇄 창을 열었는지
 */
export const printStatement = ({ root, title } = {}) => {
    const printArea = root || document.querySelector('.print-area');
    if (!printArea) {
        console.warn('[printStatement] .print-area 요소를 찾지 못해 인쇄를 열지 않았습니다.');
        return false;
    }
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.left = '-9999px';
    iframe.style.top = '0';
    iframe.style.width = '210mm';
    document.body.appendChild(iframe);
    const doc = iframe.contentDocument;
    doc.open();
    doc.write(`<html><head>${title ? `<title>${escapeHtml(title)}</title>` : ''}<style>
            body { margin: 0; padding: 20px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #333; padding: 6px 8px; font-size: 12px; }
            /* 줄공책 선 — 화면(.ledger-table)과 같은 규칙 */
            .ledger-table thead th { background: #FAFAF7 !important; color: #0f172a; font-weight: 700; border: none; border-top: 2px solid #000 !important; border-bottom: 3px double #000 !important; padding: 10px 8px !important; }
            .ledger-table tbody tr td { border: none; border-bottom: 1px solid #94a3b8 !important; padding: 8px !important; }
            .ledger-table tbody tr:last-child td { border-bottom: 2px solid #000 !important; }
            .no-print { display: none !important; }
            /* 화면 CSS(statementView.js @media print)와 같은 규칙 — innerHTML 복사라 className 스타일이 안 넘어와 여기 다시 적는다 (2026-10-24 재점검 P1-5) */
            .print-only { display: inline !important; }
            /* 수정 요청 줄 강조(노란 배경)는 치과에 가는 종이에 찍지 않는다 */
            .flagged-row { background: transparent !important; }
            /* 여러 장: 줄이 쪽 사이에서 잘리지 않게, 머리글은 쪽마다 반복 */
            tr { break-inside: avoid; page-break-inside: avoid; }
            thead { display: table-header-group; }
            @page { margin: 12mm; }
            * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
        </style></head><body>${printArea.innerHTML}</body></html>`);
    doc.close();
    try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
    } catch (e) {
        // 인쇄 창을 못 열면 기록하고 iframe 정리 (조용한 실패 금지)
        console.error('[printStatement] 인쇄 창 열기 실패:', e);
        if (iframe.parentNode) document.body.removeChild(iframe);
        return false;
    }
    setTimeout(() => { if (iframe.parentNode) document.body.removeChild(iframe); }, 1000);
    return true;
};
